import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/app/wallet-analysis/WalletAnalysisClient.tsx");
